(function () {
  'use strict';
  var widgetId = 'lb-research-elevenlabs-widget';
  var scriptId = 'lb-research-elevenlabs-script';
  function mount() {
    var root = document.querySelector('[data-research-guide]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    var panel = root.querySelector('details');
    var button = root.querySelector('[data-guide-load]');
    var status = root.querySelector('[data-guide-status]');
    var attempt = 0;
    document.querySelectorAll('[data-guide-invite]').forEach(function (opener) {
      opener.addEventListener('click', function () {
        var widget = document.getElementById(widgetId);
        if (widget) {
          widget.setAttribute('variant', 'expanded');
          widget.focus();
          return;
        }
        panel.open = true;
        root.querySelector('summary').focus();
      });
    });
    root.querySelector('[data-guide-brief]').addEventListener('click', function () {
      panel.open = false;
      var role = document.getElementById('lb-role');
      if (role) role.focus({ preventScroll: true });
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        panel.open = false;
        root.querySelector('summary').focus();
      }
    });
    button.addEventListener('click', function () {
      if (root.dataset.configured !== 'true' || !root.dataset.agentId) {
        status.textContent = root.dataset.pending;
        return;
      }
      if (button.disabled) return;
      button.disabled = true;
      status.textContent = root.dataset.loading;
      var currentAttempt = ++attempt;
      var settled = false;
      var timeout = setTimeout(fail, 12000);
      function fail() {
        if (settled || currentAttempt !== attempt) return;
        settled = true;
        clearTimeout(timeout);
        button.disabled = false;
        status.textContent = root.dataset.error;
        var script = document.getElementById(scriptId);
        if (script && !customElements.get('elevenlabs-convai')) script.remove();
      }
      function ready() {
        if (settled || currentAttempt !== attempt || !root.isConnected) return;
        settled = true;
        clearTimeout(timeout);
        var widget = document.getElementById(widgetId);
        if (!widget) {
          widget = document.createElement('elevenlabs-convai');
          widget.id = widgetId;
          var attributes = {
            'agent-id': root.dataset.agentId,
            'variant': 'expanded',
            'dismissible': 'true',
            'avatar-orb-color-1': '#337ab7',
            'avatar-orb-color-2': '#3bac49',
            'markdown-link-allowed-hosts': 'lukebattiloro.com,darpa.mil,pathfinder.theari.us,linkedin.com,instagram.com,elevenlabs.io',
            'markdown-link-include-www': 'true',
            'markdown-link-allow-http': 'false',
            'action-text': root.dataset.action,
            'start-call-text': root.dataset.start,
            'end-call-text': root.dataset.end,
            'expand-text': root.dataset.expand,
            'listening-text': root.dataset.listening,
            'speaking-text': root.dataset.speaking,
            'tabindex': '-1'
          };
          Object.keys(attributes).forEach(function (key) { widget.setAttribute(key, attributes[key]); });
          document.body.appendChild(widget);
        }
        root.hidden = true;
        widget.focus();
      }
      if (customElements.get('elevenlabs-convai')) { ready(); return; }
      customElements.whenDefined('elevenlabs-convai').then(ready).catch(fail);
      if (!document.getElementById(scriptId)) {
        var script = document.createElement('script');
        script.id = scriptId;
        script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
        script.async = true;
        script.addEventListener('error', fail, { once: true });
        document.body.appendChild(script);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
